import { apiFetch } from "../api/client";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../config";

const getAuthHeaders = () => {
  const token = localStorage.getItem("access_token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

function DashboardHome() {
  const navigate = useNavigate();

  const [devices, setDevices] = useState([]);
  const [policies, setPolicies] = useState([]);
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    loadDashboard();

    const timer = window.setInterval(() => {
      loadDashboard();
    }, 15000);

    return () => window.clearInterval(timer);
  }, []);

  const loadDashboard = async () => {
    try {
      const devicesRes = await apiFetch(`/devices`, { headers: getAuthHeaders() });
      const devicesData = await devicesRes.json();
      setDevices(Array.isArray(devicesData) ? devicesData : []);
    } catch (error) {
      console.error("Devices load error:", error);
      setDevices([]);
    }

    try {
      const policiesRes = await apiFetch(`/policies`, { headers: getAuthHeaders() });
      const policiesData = await policiesRes.json();
      setPolicies(Array.isArray(policiesData) ? policiesData : (policiesData.policies || []));
    } catch (error) {
      console.error("Policies load error:", error);
      setPolicies([]);
    }

    try {
      const logsRes = await apiFetch(`/logs`, { headers: getAuthHeaders() });
      const logsData = await logsRes.json();
      setLogs(Array.isArray(logsData) ? logsData : []);
    } catch (error) {
      console.error("Logs load error:", error);
      setLogs([]);
    }
  };

  const onlineDevices = devices.filter((d) => d.status === "online");
  const offlineDevices = devices.filter((d) => d.status === "offline");
  const warningLogs = logs.filter((l) => l.severity === "warning");

  const recentDevices = [...devices]
    .sort(
      (a, b) =>
        new Date(b.last_check_in || b.last_seen || 0) -
        new Date(a.last_check_in || a.last_seen || 0)
    )
    .slice(0, 5);

  const recentLogs = [...logs]
    .sort((a, b) => new Date(b.timestamp || 0) - new Date(a.timestamp || 0))
    .slice(0, 5);

  return (
    <div>
      <div className="stats-grid">
        <div className="stat-card clickable-card" onClick={() => navigate("/devices")}>
          <div className="stat-label">Managed Devices</div>
          <div className="stat-value">{devices.length}</div>
        </div>

        <div className="stat-card clickable-card" onClick={() => navigate("/devices")}>
          <div className="stat-label">Online Devices</div>
          <div className="stat-value">{onlineDevices.length}</div>
        </div>

        <div className="stat-card clickable-card" onClick={() => navigate("/devices")}>
          <div className="stat-label">Offline Devices</div>
          <div className="stat-value">{offlineDevices.length}</div>
        </div>

        <div className="stat-card clickable-card" onClick={() => navigate("/policies")}>
          <div className="stat-label">Policies</div>
          <div className="stat-value">{policies.length}</div>
        </div>

        <div className="stat-card clickable-card" onClick={() => navigate("/logs")}>
          <div className="stat-label">Warning Alerts</div>
          <div className="stat-value">{warningLogs.length}</div>
        </div>
      </div>

      <div className="card">
        <h2>Welcome to Wireless Press - BUILD v2.0</h2>
        <p>
          This console manages kiosk devices, tracks endpoint check-ins,
          supports policy assignment, and powers the Wireless Press lockdown platform.
        </p>
      </div>

      <div className="dashboard-two-column">
        <div className="table-card">
          <div className="section-header">
            <h3>Recent Device Check-Ins</h3>
            <button className="secondary-button" onClick={() => navigate("/devices")}>
              View All
            </button>
          </div>

          <table>
            <thead>
              <tr>
                <th>Device</th>
                <th>Status</th>
                <th>OS</th>
                <th>Last Check-In</th>
              </tr>
            </thead>
            <tbody>
              {recentDevices.length > 0 ? (
                recentDevices.map((device) => (
                  <tr
                    key={device.id}
                    className="clickable-row"
                    onClick={() => navigate(`/device/${device.id}`)}
                  >
                    <td>{device.device_name || device.hostname || "Unknown Device"}</td>
                    <td>
                      <span className={device.status === "online" ? "status-online" : "status-offline"}>
                        {device.status}
                      </span>
                    </td>
                    <td>{device.os || device.platform || "Unknown"}</td>
                    <td>{device.last_check_in || device.last_seen || "N/A"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No devices found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="table-card">
          <div className="section-header">
            <h3>Recent Activity</h3>
            <button className="secondary-button" onClick={() => navigate("/logs")}>
              View Logs
            </button>
          </div>

          <table>
            <thead>
              <tr>
                <th>Time</th>
                <th>Event</th>
                <th>Severity</th>
              </tr>
            </thead>
            <tbody>
              {recentLogs.length > 0 ? (
                recentLogs.map((log) => (
                  <tr key={log.id}>
                    <td>{log.timestamp || "N/A"}</td>
                    <td>{log.message || "No details"}</td>
                    <td>{log.severity || "info"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3">No recent activity.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default DashboardHome;